import { ConvenioService } from './../../services/convenio/convenio.service';
import { ConvenioAbonoService } from 'src/app/services/convenio-abono/convenio-abono.service';

import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';


import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import Swal from 'sweetalert2';



export interface DialogData
{
    idPlanPago: any,
    tiposRechazo: [],
    tipoRechazo: any,
    email: any,
    nombreCompleto: any,
    nombreProducto: any,
    comentarioRechazo: any
}

@Component({
    selector: 'rechazar-pago-convenio',
    templateUrl: '../../pages/convenio-abono/convenio-abono-rechazar.html',
    styleUrls: ['../../pages/convenio-abono/convenio-abono-rechazar.css']
  })
export class DialogTipoRechazoPagoConvenio
{
 tiposRechazo: any

  constructor( public dialogRef: MatDialogRef<DialogTipoRechazoPagoConvenio>,
   
    private convenioAbonoService:ConvenioAbonoService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog, )
    { 
      
    
    }
    
    ngOnInit(): void
    { this.loadData() }
    loadData()
    {
      this.convenioAbonoService.motivoRechazo(4).then
      (
          
          rechazos => {this.tiposRechazo = rechazos
             
            }
      )
      .catch ( error => {console.log(error)
    } )
    
    }
  onRechazarClick()
  {
    
    
    
    let vm = this
    
    let idMotivoRechazo = this.data.tipoRechazo.split('-')[0]
    let motivoRechazo = this.data.tipoRechazo.split('-')[1]
    
    const dialogRef = this.dialog.open(ConfirmationDialog,
      {
          data: { message: '¿Esta seguro de rechazar la Solicitud de Pago?', buttonText: { ok: 'Si', cancel: 'No' } }
      })
    dialogRef.afterClosed().subscribe((confirmed: boolean) =>
    {
      if (confirmed)
      {
        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();
        this.convenioAbonoService.rechazarPago(localStorage.getItem("idUsuario"),this.data.idPlanPago,
        idMotivoRechazo,
        motivoRechazo, this.data.comentarioRechazo).then(
          ()=>
          {
            //this.pagoPrestamo.archivo = [];
            this.openAlertDialog('La solicitud de pago de Préstamo fue rechazada exitosamente.', 'btn-success')
            
             vm.dialogRef.close()
            Swal.close();
            return false;
          }
          ) .catch ( error =>
          {
              console.log(error)
              Swal.close();
              this.openAlertDialog('Ha ocurrido un error al rechazar el pago.', 'btn-danger')
              return false;
          } )
      }
   
    })

    }
    
    onCancelarClick(): void { this.dialogRef.close() }
    
    openAlertDialog(mensaje: string, clase: string)
    {
    this.dialog.open(AlertDialogComponent, {
    data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
      })
      }
    }
    